import { render, staticRenderFns } from "./sessionsManage.vue?vue&type=template&id=0cb48156&"
import script from "./sessionsManage.vue?vue&type=script&lang=js&"
export * from "./sessionsManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports